/** Deterministic helpers for optimistic mutator replays. */

export function stableNumber(seed: string): number {
  let hash = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return Math.abs(hash);
}

export function stableId(type: string, ...parts: string[]): string {
  return `${type}_${stableNumber(parts.join(':')).toString(36)}`;
}

export function stableSequences(seed: string, count: number): number[] {
  const base = stableNumber(seed);
  return Array.from({ length: count }, (_, i) => base + i);
}
